export default {
  name: "dr-notification",
  props: {
    event: {
      type: Object,
      required: true
    },
    theme: {
      type: String,
      default: "light"
    }
  }
};
